var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.filing),function(value,key){return _c('div',{key:key},[_c('b',[_vm._v(_vm._s(key))]),_vm._v(": "+_vm._s(value)),_c('br')])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }